var map = {
	"./404.vue": [
		"8cdb",
		"404-vue"
	],
	"./BlockUser.vue": [
		"5e75",
		"BlockUser-vue"
	],
	"./CampaignHistory.vue": [
		"13b3",
		"CampaignHistory-vue"
	],
	"./Category.vue": [
		"4886",
		"Category-vue"
	],
	"./ChampionBattleGame.vue": [
		"e9a8",
		"ChampionBattleGame-vue"
	],
	"./Dashboard.vue": [
		"7277",
		"Dashboard-vue"
	],
	"./GameUpdate.vue": [
		"5be3",
		"GameUpdate-vue"
	],
	"./Gratification.vue": [
		"a740",
		"Gratification-vue"
	],
	"./Layout.vue": [
		"88e9",
		"Layout-vue"
	],
	"./Leaderboard.vue": [
		"6950",
		"Leaderboard-vue"
	],
	"./Login.vue": [
		"a55b",
		"Login-vue"
	],
	"./NewGameUpload.vue": [
		"e0fa",
		"NewGameUpload-vue"
	],
	"./RevenueReport.vue": [
		"b9bc",
		"RevenueReport-vue"
	],
	"./Tables.vue": [
		"8840d",
		"Tables-vue"
	],
	"./Tournament.vue": [
		"1794",
		"Tournament-vue"
	],
	"./UserHistory.vue": [
		"081f",
		"UserHistory-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;